import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";

export class DestinatarioInternoDTO {
  codice: string;
  cmu: string;
  nome: string;
  tipoDestinatario: TipoDestinatarioEnum;
}
